import { findGrapesJSComponent } from '../../../domUtils';

const CustomWidgetComponent = (editor) => {
	editor.DomComponents.addType(
		'custom-widget',
		{
			isComponent: (el) => {
				const classNames = el?.attributes?.class?.value;
				const isComp = classNames?.includes('widget-item-wrapper');
				return isComp;
			},
			model: {
				// Default properties
				defaults: {
					tagName: 'div',
					highlightable: true,
					draggable: 'div[class*="widgets-wrapper"]', // Can be dropped only inside `form` elements
					droppable: false, // Can't drop other elements inside
					attributes: {
						class: 'column each-section widget-item-wrapper',
						configurable: true,
					},
					removable: true,
					badgable: false,
					copyable: false,
					resizable: false,
					selectable: true,
					editable: true,
					traits: [],
				},
			},
			view: {
				tagName: 'div',
				// Do something with the content once the element is rendered.
				// The DOM element is passed as `el` in the argument object,
				// but you can access it from any function via `this.el`
				onRender(props) {
					// console.log('onRender customImage', props);
					const { el } = props;

					const buttonRowDiv = document.createElement('div');
					buttonRowDiv.classList.add('widget-item-toolbar');
					const editBtn = document.createElement('button');
					editBtn.innerHTML =
						'<svg style="width:24px;height:24px" viewBox="0 0 24 24"><path fill="currentColor" d="M2,6V8H14V6H2M2,10V12H14V10H2M20.04,10.13C19.9,10.13 19.76,10.19 19.65,10.3L18.65,11.3L20.7,13.35L21.7,12.35C21.92,12.14 21.92,11.79 21.7,11.58L20.42,10.3C20.31,10.19 20.18,10.13 20.04,10.13M18.07,11.88L12,17.94V20H14.06L20.12,13.93L18.07,11.88M2,14V16H10V14H2Z" /></svg>';
					editBtn.classList.add('editor-button');
					editBtn.addEventListener('click', () => {
						editor.runCommand('openConfigurationEditor', {
							sectionId: `#section-calculator`,
							widgetContainerId: `#${el.id}`,
						});
					});
					buttonRowDiv.appendChild(editBtn);
					const dragButton = document.createElement('button');
					dragButton.innerHTML = `<svg style="width:24px;height:24px" viewBox="0 0 24 24"><path fill="currentColor" d="M22.67,12L18.18,16.5L15.67,14L17.65,12L15.67,10.04L18.18,7.53L22.67,12M12,1.33L16.47,5.82L13.96,8.33L12,6.35L10,8.33L7.5,5.82L12,1.33M12,22.67L7.53,18.18L10.04,15.67L12,17.65L14,15.67L16.5,18.18L12,22.67M1.33,12L5.82,7.5L8.33,10L6.35,12L8.33,13.96L5.82,16.47L1.33,12M12,10A2,2 0 0,1 14,12A2,2 0 0,1 12,14A2,2 0 0,1 10,12A2,2 0 0,1 12,10Z" /></svg>`;
					dragButton.classList.add('editor-button', 'icon-button');
					// This is just an example, AVOID adding events on inner elements,
					// use `events` for these cases
					dragButton.addEventListener('mousedown', (event) => {
						const component = findGrapesJSComponent(`#${el.id}`);
						component.set('draggable', 'div[class*="widgets-wrapper"]');
						editor.runCommand('tlb-move', {
							target: component,
							event,
						});
						// item.em.delete();
					});
					buttonRowDiv.appendChild(dragButton);
					const btn = document.createElement('button');
					btn.innerHTML = `<svg style="width:24px;height:24px" viewBox="0 0 24 24"><path fill="currentColor" d="M13.46,12L19,17.54V19H17.54L12,13.46L6.46,19H5V17.54L10.54,12L5,6.46V5H6.46L12,10.54L17.54,5H19V6.46L13.46,12Z" /></svg>`;
					btn.classList.add('editor-button', 'delete-button', 'icon-button');
					const handleEventCallback = () => {
						const component = findGrapesJSComponent(`#${el.id}`);
						if (component) {
							component.remove();
						}
					};
					btn.addEventListener('click', handleEventCallback);
					btn.addEventListener('touchstart', handleEventCallback);
					buttonRowDiv.appendChild(btn);
					el.append(buttonRowDiv);
				},
			},
		} /* API for component type definition */,
	);
};

export default CustomWidgetComponent;
